import { VideoSizesHandlerStrategy } from './video-sizes-handler-strategy';
import {
  GetStandardBannersSpecificRule,
  StandardBannersSpecificRule
} from '../standard-banners/get-standard-banners-specific-rule';
import { reaction } from '../../../../../common/js/utils/preact-utils';
import { getOgAdContext } from '../../../../../common/js/environment-utils';
import { VideoStore } from '../../../../../common/js/stores/video.store';
import { AnalyticsStore } from '../../../../../common/js/stores/analytics.store';
import { ConfigStore } from '../../../../../common/js/stores/config.store';
import { IVideoSizes } from '../../../../../common/js/video-utils';

interface AdContext {
  [key: string]: any;
}

export class StandardBannersVideoSizesHandlerStrategy extends VideoSizesHandlerStrategy {
  videoStore: VideoStore;
  configStore: ConfigStore;
  adContext: AdContext;

  constructor(videoStore: VideoStore, analyticsStore: AnalyticsStore) {
    super(analyticsStore);
    this.videoStore = videoStore;
    this.configStore = videoStore.configStore;
    this.adContext = videoStore.adContext;
    this.handleBlurActivation();
  }

  reactToSizes(videoSizes: IVideoSizes): void {
    super.reactToSizes(videoSizes);

    if (!videoSizes.video_height || !videoSizes.video_width) {
      return;
    }
    const ogAdContext = getOgAdContext();
    const formatSizeResponse = ogAdContext.format_size_response;
    if (!formatSizeResponse) {
      return;
    }
    const expected = formatSizeResponse.split('x');
    if (expected.length !== 2) {
      return;
    }
    const [expectedWidth, expectedHeight] = expected.map(Number);
    if (
      videoSizes.video_width !== expectedWidth ||
      videoSizes.video_height !== expectedHeight
    ) {
      this.analyticsStore.sendEvent(
        'monitoring',
        'format_size_response_discrepencies'
      );
    }
  }

  handleBlurActivation(): void {
    const callback = (closestRatio: number) => {
      const rule = GetStandardBannersSpecificRule(closestRatio);
      if (rule === StandardBannersSpecificRule.BLUR) {
        if (!this.configStore.config.video?.isBlurBackground) {
          this.configStore.alterConfiguration({
            video: { isBlurBackground: true }
          });
        }
        deleteVideoClosestRatioReaction && deleteVideoClosestRatioReaction();
      }
    };

    const deleteVideoClosestRatioReaction = reaction(
      () => this.videoStore.videoClosestRatio.value,
      callback
    );

    // run the callback once with the current value, if ratio is already found
    callback(this.videoStore.videoClosestRatio.value);
  }
}
